<template>
	<div>
		<section class="hero hero--course">
			<div class="container">
				<div class="hero__wrapper hero__wrapper--centered">
					<h2 class="hero__primary">Getting Better with your life</h2>
					<p class="hero__secondary pt-20">Courses found on our platform</p>
				</div>
			</div>
		</section>

		<section class="section">
			<h3 class="section__title">Recommended Courses</h3>
			<h6 class="section__secondary sub-title">The courses below are recommended based on your career choice.</h6>
			<div class="container">
				<template v-if="loadingClasses">
					<div class="loading">
						<loader />
					</div>
				</template>
				<template v-else>
					<template v-if="classesLoaded && classes.length">
						<div class="features__grid">
							<div class="features__grid__item"
								 v-for="classItem in classes"
								 :key="classItem.id">
								<div class="features__img">
									<img :src="classItem.avatar" alt="">
								</div>
								<div class="features__body">
									<div>
										<h5 class="bold">
											{{classItem.title}}
										</h5>
										<p class="text" v-html="classItem.description"></p>
									</div>
									<router-link
											v-if="isJoined(classItem.id) === 'Resume Learning'"
											:to="{
											name: 'course-detail',
											params: { id: classItem.id }}">
										<button
												:class="{ isJoined: isJoined(classItem.id) === 'Resume Learning' }"
												class="btn__primary btn__primary--wide">
											{{ isJoined(classItem.id) }}
										</button>
									</router-link>
									<button
											v-else
											@click="joinCourse(classItem.id)"
											class="btn__primary btn__primary--wide">
										{{ isJoined(classItem.id) }}
									</button>
								</div>
							</div>
						</div>
						<div class="features__footer">
							<Pagination
									v-if="total > limit"
									:options="{ limit, offset, total, baseUrl }"/>
						</div>
					</template>
					<template v-else-if="classesLoaded">
						<br/>
						<div class="alert alert-warning center" role="alert">
							<strong>Warning!</strong> No course available for your career choice.
						</div>
					</template>
					<template v-else>
						Error loading classes
					</template>
				</template>
			</div>
		</section>
	</div>
</template>

<script>
  import { setTimeout } from 'timers';
  import { mapGetters, mapMutations } from 'vuex';
  import { joinCourse, getFilteredCourses } from '../../utils/api/course';
  import Loader from '../../components/Loader';
  import Pagination from '../../components/Pagination';
  import { success, fail } from '../../utils/toast';

  export default {
    name: 'Index',
    components: {
      Loader,
      Pagination
    },
    data() {
      return {
        classes: [],
        loadingClasses: true,
        classesLoaded: false,
        limit: 6,
        offset: 0,
        total: 0,
        baseUrl: 'courses',
        status: 1
      };
    },
    mounted() {
      if (this.userObject.is_credential_uploaded !== 1) {
        success({
          title: 'Notice!',
          text: 'Kindly update your credentials to proceed, you are being redirected.',
          timer: 8000
        });
        setTimeout(() => {
          this.$router.push({ name: 'user-profile', params: { id: this.$session.get('id') } });
        }, 5000);
      } else if (this.userObject.is_psychometric_completed !== 1) {
        swal.fire({
          type: 'info',
          title: 'Notices!',
          text: 'You have already completed the psychometric test',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: 'test' });
          }
        });
      }
    },
    created() {
      this.getFilteredCourses();
      this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
      this.offset = this.$route.query.offset ? this.$route.query.offset : this.offset;
      if (!this.userObject.is_career_selected) {
        swal.fire({
          type: 'warning',
          title: 'Notice!',
          text: 'You have not selected a career path, redirecting to careers page',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: 'careers' });
          }
        });
      }
      if (!this.userObject.is_credential_uploaded) {
        swal.fire({
          type: 'warning',
          title: 'Notice!',
          text: 'You yet to upload your credential, please do so to continue',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: 'user-profile', params: { id: this.userObject.id } });
          }
        });
      }
      if (!this.userObject.is_psychometric_completed) {
        swal.fire({
          type: 'warning',
          title: 'Notice!',
          text: 'You are yet to complete your psychometric test',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: 'test' });
          }
        });
      }
    },
    computed: {
      ...mapGetters({
        userObject: 'userObject',
        getUserCourses: 'getUserCourses',
        joinedCourse: 'getJoinedStatus',
        getLessonId: 'getLessonIds'
      })
    },
    methods: {
      ...mapMutations([
        'setJoinedCourse',
        'resetJoinedCourse',
        'setLessonIds',
        'updateUserCourses'
      ]),
      joinCourse(id) {
        joinCourse(id, { user_id: this.userObject.id })
          .then((response) => {
            if (response.status === 201) {
              this.updateUserCourses(response.data);
              this.setJoinedCourse(true);
              success({
                title: 'Success! You have successfully joined the course!.'
              });
              setTimeout(() => {
                this.$router.push({
                  name: 'course-detail',
                  params: { id }
                });
              }, 1000);
            }
          }).catch((error) => {
          fail({
            title: 'Oops! Something went wrong',
            text: error.data
          });
          return error;
        });
      },
      isJoined(id) {
        const status = this.getUserCourses.find(course => course.class_id === id);
        return status ? 'Resume Learning' : 'Start Learning';
      },
      getFilteredCourses() {
        getFilteredCourses(this.status, this.userObject.career.career_id)
          .then((response) => {
            if (response.status === 200) {
              this.classes = response.data.data;
              this.classesLoaded = true;
              return true;
            }
            this.classesLoaded = false;
            return false;
          })
          .catch((error) => {
            this.classesLoaded = true;
            return error;
          })
          .finally(() => {
            this.loadingClasses = false;
          });
        return true;
      }
    }
  };
</script>

<style lang="scss" scoped>
	.course__link {
		color: inherit;
		&:hover {
			color: $green;
		}
	}

	.features {
		&__img {
			img {
				min-height: 165px;
				max-height: 165px;
				object-fit: cover;
				object-position: 50% 50%;
			}
		}
		&__body {
			.text {
				min-height: 100px;
			}
		}
	}
	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}
	.center {
		text-align: center;
	}
	.isJoined {
		color: $green!important;
		border: 1px solid $green;
		background: $white;
	}
	.features__body {
		padding: 18px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.features__grid__item {
		border-radius: 6px;
		display: grid;
		grid-auto-rows: 165px 1fr;
	}
</style>
